import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsProtondbComponent } from './simple-icons-protondb.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsProtondbComponent ],
    exports:      [ SimpleIconsProtondbComponent ],
    bootstrap:    []
})
export class SimpleIconsProtondbModule {}
